export const getFriendlyPrice = (price: number) => {
  return `$${price.toFixed(2)}`
}
